import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import { initializeApp } from 'firebase/app'

import { CenterModalProvider } from '@src/contexts/popup/modal/CenterModalProvider'

import App from './App'
import reportWebVitals from './reportWebVitals'
import AppWrapper from '@src/components/common/AppWrapper'
import { FIREBASE_CONFIG } from './utils/constants'

const app = initializeApp(FIREBASE_CONFIG)

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<RecoilRoot>
				<CenterModalProvider>
					<AppWrapper>
						<App />
					</AppWrapper>
				</CenterModalProvider>
			</RecoilRoot>
		</QueryClientProvider>
	</React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
